import { useMemo } from "react";

function useDetectKeelMind(ignoreSlashMind = false) {
    return useMemo(
        () =>
            window.location.hostname.includes("keelmind.com") ||
            (!ignoreSlashMind && window.location.pathname.includes("mind")),
        [ignoreSlashMind]
    );
}

export default useDetectKeelMind;
